export default __webpack_public_path__ + "static/media/imagine-logo.6317e69e.svg";